import { ListItem, Flex, Box } from '@chakra-ui/react';
import { IRecordedInterviewScores } from 'types';
import { Link as RouteLink } from 'react-router-dom';
import { ScoreBadge, AudioQialityBadge } from 'shared-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { isNil, isUndefined } from 'lodash';

interface IProps {
  question: string;
  index: number;
  data?: IRecordedInterviewScores;
  isScored: boolean | undefined;
  canEditScoresAndAssessment: boolean;
  canViewScoresAndAssessment: boolean;
}
export default function Question({
  question,
  index,
  data,
  isScored,
  canEditScoresAndAssessment,
  canViewScoresAndAssessment,
}: IProps) {
  const { questionNo, answerScore, answerExplanation, originalTranscriptScore } = data ?? {};

  const notFirstQuestion = questionNo && questionNo > 1;

  const showQuestion = isNil(isScored) ? notFirstQuestion : isScored;

  const shouldShowAIAssessment =
    (canEditScoresAndAssessment || canViewScoresAndAssessment) && showQuestion && !isUndefined(answerScore);

  const showEditUI = canEditScoresAndAssessment && showQuestion;

  const backupQuestionNo = index + 1;

  const linkProps = showEditUI && {
    as: RouteLink,
    to: `questions/${questionNo ?? backupQuestionNo}`,
    _hover: { bgColor: 'hover-bg' },
    _active: { bgColor: 'active-bg' },
  };

  return (
    <ListItem ml={0} _odd={{ bgColor: 'chakra-subtle-bg' }}>
      <Flex gap={2} px={{ base: 3, md: 4 }} py={3} {...linkProps}>
        <Box textAlign="right" width="6" flexShrink="0">
          {questionNo ?? backupQuestionNo}.
        </Box>

        <Box flexGrow="1">
          <Box fontWeight="medium">{question}</Box>

          {shouldShowAIAssessment && (
            <>
              <Flex fontSize="sm" pt="2">
                <Box mr="2">{!isUndefined(answerScore) && <ScoreBadge value={answerScore} withIndicator />}</Box>

                {!!answerExplanation && (
                  <Box lineHeight="4" color="muted">
                    {answerExplanation}
                  </Box>
                )}
              </Flex>
              {showEditUI && !isUndefined(originalTranscriptScore) && (
                <Box mt="2" ml="9">
                  <AudioQialityBadge value={originalTranscriptScore} />
                </Box>
              )}
            </>
          )}
        </Box>

        {showEditUI && (
          <Box alignSelf={'center'} color={'link-color'}>
            <FontAwesomeIcon icon={faChevronRight} fixedWidth />
          </Box>
        )}
      </Flex>
    </ListItem>
  );
}
